import React from "react";
import { useLoader } from "../utils/LoaderUtils";

function FullPageLoader() {
    const { isLoading } = useLoader();

    if (!isLoading) return null;

    return (
        <div className="loader-overlay">
            <div className="loader-content">
                <img
                    //   loading="lazy"
                    src="/assets/images/axeselllogo.webp"
                    alt="Logo"
                    style={{ width: "150px" }}
                />

                <div className="loader-spinner"></div>
            </div>
        </div>
    );
}

export default FullPageLoader;